module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "localRecipient",
    attrs: {
      "label-position": "left",
      "label-width": "150px",
      "model": _vm.localRecipient,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "Email Address"
    },
    on: {
      "clear": _vm.clearForm,
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "value"
        }, [_vm._v(_vm._s(item.email))])]
      }
    }]),
    model: {
      value: (_vm.localRecipient.email),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "email", $$v)
      },
      expression: "localRecipient.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "firstName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.localRecipient.firstName),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "firstName", $$v)
      },
      expression: "localRecipient.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Surname",
      "prop": "lastName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Surname"
    },
    model: {
      value: (_vm.localRecipient.lastName),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "lastName", $$v)
      },
      expression: "localRecipient.lastName"
    }
  })], 1), _vm._v(" "), (_vm.companies.length) ? _c('el-form-item', {
    attrs: {
      "label": "Company",
      "prop": "companyId",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "clearable": true,
      "filterable": true
    },
    model: {
      value: (_vm.localRecipient.companyId),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "companyId", $$v)
      },
      expression: "localRecipient.companyId"
    }
  }, _vm._l((_vm.companies), function(company) {
    return _c('el-option', {
      key: company.id,
      attrs: {
        "label": company.title,
        "value": parseInt(company.id)
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reports"
    }
  }, [_c('div', [_c('el-checkbox', {
    attrs: {
      "size": "small",
      "label": "Campaign Summary",
      "border": ""
    },
    model: {
      value: (_vm.localRecipient.campaignSummary),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "campaignSummary", $$v)
      },
      expression: "localRecipient.campaignSummary"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "size": "small",
      "label": "Survey Summary",
      "border": ""
    },
    model: {
      value: (_vm.localRecipient.surveySummary),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "surveySummary", $$v)
      },
      expression: "localRecipient.surveySummary"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "size": "small",
      "label": "Programming Summary",
      "border": ""
    },
    model: {
      value: (_vm.localRecipient.programmingSummary),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "programmingSummary", $$v)
      },
      expression: "localRecipient.programmingSummary"
    }
  })], 1)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.savingRecipient,
      "plain": ""
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b8f75a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/automatedemails/recipients/RecipientManage.vue
// module id = 3214
// module chunks = 3